import axios from 'axios';

const state = () => ({
  list: [],
  cursor: null,
});

const mutations = {
  RESET(s) {
    Object.assign(s, state());
  },
  SET_LIST(state, { list, cursor }) {
    state.list = list;
    state.cursor = cursor;
  },
  ADD_ENTRY(state, entry) {
    state.list.unshift(entry);
  },
  UPDATE_ENTRY(state, entry) {
    const index = state.list.findIndex(k => k.ID === entry.ID);
    if (index > -1) state.list.splice(index, 1, entry);
    else state.list.unshift(entry);
  },
  PATCH_ENTRY(state, entry) {
    const index = state.list.findIndex(k => k.ID === entry.ID);
    if (index > -1) Object.assign(state.list[index], entry);
  },
  REMOVE_ENTRY(state, ID) {
    const index = state.list.findIndex(k => k.ID === ID);
    if (index > -1) state.list.splice(index, 1);
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
  async list({ commit, state }, {
    filter,
    order,
    abortSignal = null,
  }) {
    let resetList = false;
    if (!state.cursor) resetList = true;

    const { data } = await axios.get('v2/license-plate', {
      params: {
        filter,
        order,
        cursor: state.cursor,
      },
      signal: abortSignal,
    });

    if (abortSignal && abortSignal.aborted) return;

    const { list, cursor } = data;

    commit('SET_LIST', {
      list: resetList ? list : state.list.concat(list),
      cursor,
    });

    return !!cursor; // isMore?
  },
  async create({ commit }, licensePlate) {
    const { data } = await axios.post('v2/license-plate', licensePlate);
    commit('ADD_ENTRY', data.licensePlate);
    return data.licensePlate;
  },
  async update({ commit }, licensePlate) {
    await axios.post(`v2/license-plate/${licensePlate.ID}`, licensePlate);
    commit('UPDATE_ENTRY', licensePlate);
  },
  async get({ commit }, ID) {
    const { data } = await axios.get(`v2/license-plate/${ID}`);
    commit('UPDATE_ENTRY', data.licensePlate);
    return data.licensePlate;
  },
  async remove({ commit }, ID) {
    await axios.delete(`v2/license-plate/${ID}`);
    commit('REMOVE_ENTRY', ID);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
